import { motion } from "framer-motion";
import { XCircle } from 'lucide-react';

const pains = [
"Tempo no trânsito para chegar à escola",
"Horário da escola atrapalhando sua rotina",
"Escola tradicional focada só em gramática",
"App de frases prontas que você repete sem entender",
"Curso que promete fluência milagrosa",
"Nenhum contato com professor real"];


export default function PainSection() {
  return (
    <section className="bg-gray-100 md:py-20 pt-[40px] pb-[40px]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-serif text-3xl md:text-4xl font-bold text-blue-900 text-center mb-10">

          Você já tentou aprender inglês assim:
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {pains.map((pain, i) =>
          <motion.div
            key={i}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.08 }}
            className="flex items-start gap-3 bg-white rounded-xl p-4 shadow-sm">

              <XCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" />
              <span className="text-gray-700 text-base">{pain}</span>
            </motion.div>
          )}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center space-y-2">

          <p className="text-gray-700 text-lg">Começa animado… e desiste no meio.</p>
          <p className="text-blue-900 text-xl font-bold">O problema não é você.</p>
          <p className="text-red-600 text-xl font-bold">É o modelo errado.</p>
          <p className="text-gray-600 text-base mt-4">
            A maioria dos cursos ensina conteúdo.<br />
            Mas não ensina você a evoluir.
          </p>
        </motion.div>
      </div>
    </section>);

}